import { render, staticRenderFns } from "./SidemenuIcon.vue?vue&type=template&id=028fa632&scoped=true&"
import script from "./SidemenuIcon.vue?vue&type=script&lang=js&"
export * from "./SidemenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./SidemenuIcon.vue?vue&type=style&index=0&id=028fa632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028fa632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028fa632')) {
      api.createRecord('028fa632', component.options)
    } else {
      api.reload('028fa632', component.options)
    }
    module.hot.accept("./SidemenuIcon.vue?vue&type=template&id=028fa632&scoped=true&", function () {
      api.rerender('028fa632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/SidemenuIcon.vue"
export default component.exports